<template>
  <div class="modal fade" tabindex="-1" role="dialog" v-on:keyup.enter="confirm">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
          <h4 class="modal-title">{{ title }}</h4>
        </div>
        <div class="modal-body">
          <p>{{ message }}</p>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-default" data-dismiss="modal">Cancel</button>
          <button v-on:click="confirm" type="button" class="btn btn-danger" data-dismiss="modal">Confirm</button>
        </div>
      </div><!-- /.modal-content -->
    </div><!-- /.modal-dialog -->
  </div>
</template>

<script>
  export default {
    props: ['message', 'title'],
    name: 'ConfirmModal',
    methods: {
      confirm () {
        window.jQuery('#ConfirmModal').modal('hide')
        this.$emit('confirm')
      }
    }
  }
  
</script>



// WEBPACK FOOTER //
// ConfirmModal.vue?bc82c8c0